import { useMutation } from "react-query";
import { PagarMultiplasContasForm } from "../typings";
import http from "infra/http";


function usePagarContasMultiplas() {

    return useMutation(
        (data: PagarMultiplasContasForm) => {
            return http.post(`/v1/conta/pagar-multiplas`, data);
        },

    );
}

export default usePagarContasMultiplas;
